import { apiService } from "../apiService"

const fetchCars = async(userId: string) => {
  try {
    const { data } = await apiService.CarsApi.getCars({userId: userId})
    return data
  } catch (error) {
    console.log(error)
  }
}

export default fetchCars
